import { render } from "./InvoiceResendPage.vue?vue&type=template&id=3412a9cf&scoped=true&ts=true"
import script from "./InvoiceResendPage.vue?vue&type=script&lang=ts"
export * from "./InvoiceResendPage.vue?vue&type=script&lang=ts"

import "./InvoiceResendPage.vue?vue&type=style&index=0&id=3412a9cf&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3412a9cf"]])

export default __exports__